<template>
  <div>
    <b-loading :active="isGettingDraft || loadingSubmit" />
    <div class="mx-10 my-11 sm:mx-1">
      <div class="flex flex-col mb-8">
        <w-button
          class="wrapper__go-back"
          type="text"
          @click="goBack"
        >
          <i class="icon icon-chevron-left-bold text-gray-500" />
          返回一起訂東西
        </w-button>
        <progress-bar
          v-if="!inViewResultMode"
          :disable-pre="inViewResultMode"
          :is-draft="false"
          :steps="steps"
          v-model="currentStepIndex"
        />
      </div>
      <template v-if="!isLoading">
        <member-selector
          v-if="isStepMemberSelector"
          :allow-edit-type="allowEditType"
          :order-type="draftBuyingMethod"
        />
        <order-config
          v-if="isStepOrderConfig"
          :allow-edit-type="allowEditType"
          :order-type="draftBuyingMethod"
          :title="inViewResultMode ? '檢視訂購資訊' : '修改訂購資訊'"
          :view-mode="inViewResultMode"
        />
      </template>
    </div>
    <div
      v-if="showActionBar && !loadingOrder"
      class="wrapper__action-bar"
      :class="{ 'ml-0 sm:ml-0': isSidebarCollapsed }"
    >
      <template v-if="!inViewResultMode">
        <w-button
          class="mr-6"
          type="link"
          @click="goBack"
        >
          取消
        </w-button>
        <w-button
          :disabled="isLoading || loadingSubmit || !isNextStepEnabled"
          @click="onSubmit"
        >
          {{ nextStepButtonText }}
        </w-button>
      </template>
      <w-button
        v-else
        :disabled="isLoading || loadingSubmit"
        @click="goBack"
      >
        返回
      </w-button>
    </div>
  </div>
</template>

<script>
import EditOrder from './EditOrder';

export default EditOrder;
</script>

<style lang="scss" scoped>
@import 'EditOrder';
</style>
